// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"7ff9085e","437":"dd0c2db5","453":"874d65d5","741":"6600d378","898":"3b88c91d"}[chunkId] + ".chunk.js";
};